import { Fragment, type ReactElement } from "react";

import { FiltersChip } from "../FiltersChip/FiltersChip";

import { StyledChipsContainer, StyledChipsDivider } from "./styles";

export type ChipGroupItem<T = string> = {
    name: string;
    type: T;
};

type ChipsGroupProps<T = string> = {
    chipItems: ChipGroupItem<T>[];
    onDelete: (item: ChipGroupItem<T>) => void;
    divider?: string;
};

const ChipsGroup = <T extends string>({ chipItems, divider, onDelete }: ChipsGroupProps<T>): ReactElement => {
    return (
        <StyledChipsContainer>
            {chipItems.map((chip: ChipGroupItem<T>, i: number) => {
                return (
                    <Fragment key={i}>
                        {i > 0 ? <StyledChipsDivider>{divider}</StyledChipsDivider> : null}
                        <FiltersChip
                            text={chip.name}
                            onClose={() => onDelete(chip)}
                        />
                    </Fragment>
                );
            })}
        </StyledChipsContainer>
    );
};

export default ChipsGroup;
